export default "__VITE_ASSET__CJMPa9rg__"